<template>
    <b-navbar
      toggleable="lg"
      variant="light"
    >
    <b-navbar-brand
      :to="{ name: 'Home' }"
    >
      <b-img
        src="../../assets/logo.png"
        alt="Hoops Yard"
        width="120"
      ></b-img>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{ name: 'Bookings' }">Canchas</b-nav-item>
        <b-nav-item :to="{ name: 'Hoops5x5Challenge' }">Juegos</b-nav-item>
        <b-nav-item :to="{ name: 'Leagues' }">Ligas</b-nav-item>
        <b-nav-item href="./hoops-yard-sponsorship.pdf">Patrocinios</b-nav-item>
        <b-nav-item :to="{ name: 'About' }">Nosotros</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
}
</script>
